export default __webpack_public_path__ + "static/media/IMG_4917.911fa2c3.png";